"use client";

import ThemeSelector from "@/components/common/theme-selector";

export default function LandingPage() {
  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-background to-background/80">
      <main className="flex-1"></main>

      <ThemeSelector />
    </div>
  );
}
